import { observable } from "mobx";
import { Type } from "class-transformer";
import PartnerMessageListItem from "./partnerMessageListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RspPartnerMessageList {
  @observable
  total!: number;

  @observable
  @Type(() => PartnerMessageListItem)
  messages!: PartnerMessageListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    messages: { required: true },
  };
}
